<template>
  <div>
    <div class="items mt-40">
      <el-row
        type="flex"
        justify="space-between"
        class="item pb-20"
      >
        <span class="item-property">
          {{ $t('organization.name') }}
        </span>
        <span class="item-value">
          {{ organization.name }}
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="item pt-20 pb-20"
      >
        <span class="item-property">
          {{ $t('organization.resp-contact') }}
        </span>
        <span class="item-value">
          {{ organization.representativeName }} {{ organization.representativeLastname }}
        </span>
      </el-row>
    </div>
    <el-row class="buttons mt-20">
      <el-col :span="11">
        <el-button
          type="default"
          class="primary-outline-button"
          @click="deleteOrganizationDialogVisible = true"
        >
          {{ $t('form.delete') }}
        </el-button>
      </el-col>
      <el-col
        :offset="1"
        :span="11"
      >
        <router-link
          :to="{name: 'EditOrganization'}"
          custom
          v-slot="{ navigate }"
        >
          <el-button
            type="primary"
            class="primary-button"
            @click="navigate"
          >
            {{ $t('form.edit') }}
          </el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-dialog
      :title="$t('form.delete')"
      :visible.sync="deleteOrganizationDialogVisible"
      width="320px"
      :center="true"
      :show-close="false"
      class="confirm-dialog delete-organization-dialog"
    >
      <span>{{ $t('organization.wanna-delete') }}</span>
      <span
        slot="footer"
      >
        <el-row>
          <el-button
            type="primary"
            @click="deleteOrganization"
            class="primary-button"
          >
            {{ $t('yes') }}
          </el-button>
        </el-row>
        <el-row class="mt-20">
          <el-button
            type="text"
            @click="deleteOrganizationDialogVisible = false"
            class="primary-link"
          >
            {{ $t('no') }}
          </el-button>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  props: {
    organization: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: () => ({
    deleteOrganizationDialogVisible: false
  }),
  methods: {
    deleteOrganization () {
      this.$adminApi.delete('/api/v1/entities/' + this.$route.params.id).then((response) => {
        if (response.data.status === 'Deleted') {
          this.$message.success(this.$t('form.item-deleted', { item: this.$t('organization.title') }));
          this.$router.push({ name: 'Organizations' });
        } else {
          this.$message.warning(response.data.status);
        }
      }).catch(() => {
        this.$message.error(this.$t('form.something-wrong'));
      });
    }
  }
};
</script>

<style scoped lang="scss">
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      padding-left: 24px;
    }

    &-value {
      font-family: "Raleway Bold", serif;
      font-size: 16px;
      padding-right: 24px;
    }
  }
}

.buttons {
  text-align: center;

  button {
    width: 164px;
    height: 54px;
    border-radius: 15px;
    font-family: "Raleway Medium", serif;
    font-size: 18px;

    &.delete-button {
      border: 2px solid #FF8A00;
      color: #FF8A00;
    }
  }
}

.delete-organization-dialog::v-deep {
  .el-dialog__body {
    white-space: normal;
  }
}
</style>
